import { ApiModel, ApiModelOptions } from "../../../ApiModel";
import { LocationModel } from "../../../models";

export default function apiLocationModel(opts: ApiModelOptions<LocationModel>) {
  return ApiModel<LocationModel>("location", opts);
}
